module.exports = __webpack_public_path__ + "img/banner-scholarship@3x.101bde60.jpg";